// app/utils/getTaxRate.ts
export const getTaxRate = (): number => {
    let channel = "";
    if (typeof document !== "undefined") {
        const match = document.cookie.match(/(?:^|;\s*)selectedStore=([^;]+)/);
        channel = match ? decodeURIComponent(match[1]) : "";
    }

    let taxRate = 0;
    switch (channel) {

        default:
            taxRate = 0;
    }
    return taxRate;
};